import { AuthLayout, RegisterForm } from '../components/features/auth';
import { MountainBackground } from '../components/layout';

export function RegisterPage() {
  return (
    <MountainBackground variant="prominent">
      <AuthLayout
        title="Start your journey"
        subtitle="Create an account to begin your path to recovery"
      >
        <RegisterForm />
      </AuthLayout>
    </MountainBackground>
  );
}
